
export function Split(value: string, position: number, char: string) {
    return value.split(char)[position];
}

export function CampoNuloOVacio(campo: string): boolean {
    return campo == null || campo == "" || campo == undefined;
};